export enum TrafficCoverageLevel {
  VeryLow,
  Low,
  Medium,
  High,
  Max,
}

export enum HeatmapIndicatorState {
  UNAVAILABLE = 'unavailable',
  FILTERS_APPLIED = 'filters',
  MEASURING = 'measuring',
  LOW = 'low',
  MID = 'mid',
  HIGH = 'high',
  MAX = 'max',
}
